export const MENU_ACCOUNT = [
  {
    label: 'Account details',
    href: '/account-details',
    allowedNonSubscriber: false,
  },
  {
    label: 'Saved addresses',
    href: '/addresses',
    allowedNonSubscriber: false,
  },
  {
    label: 'Saved payment methods',
    href: '/payment-methods',
    allowedNonSubscriber: false,
  },
  {
    label: 'Previous orders',
    href: '/previous-orders',
    allowedNonSubscriber: true,
  },
  {
    label: 'Log out',
    href: '/logout',
    allowedNonSubscriber: true,
  },
]
